import { __makeTemplateObject } from "tslib";
import styled from '@marvelapp/styled';
var Semibold = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 600;\n"], ["\n  font-weight: 600;\n"])));
export default Semibold;
var templateObject_1;
